<template>
  <div class="logo-box flex align-center">
    <img :src="logoUrl" alt="logo" height="30" />
    <div class="to-link" @click="goCCB"></div>
    <div class="to-switch" @click="toSwitch" @mouseleave="dialogVisible = false">
      <div class="select-menu-list" v-if="dialogVisible">
        <div class="list-item flex align-center cursor-pointer" @click="goCC">
          <img :src="ccLogo" alt="logo" width="40" />
          <div class="flex-1">
            <div class="name">Camcard</div>
            <div class="desc">{{ isCn ? '个人名片管理' : 'Personal card management' }}</div>
          </div>
        </div>
        <div class="list-item flex align-center cursor-pointer" @click="goCCB">
          <img :src="ccbLogo" alt="logo" width="40" />
          <div class="flex-1">
            <div class="name">Camcard Business</div>
            <div class="desc">{{ isCn ? '企业名片管理' : 'Business card management' }}</div>
          </div>
          <i class="icomoon-check"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, getCurrentInstance, ref } from 'vue'
  import store from '@/store'
  import logoZh from '@/images/site/logo_zh.png'
  import logoEn from '@/images/site/logo_en.png'
  import ccLogo from '@/images/cc.png'
  import ccbLogo from '@/images/ccb.png'
  import CONFIG from '@/config'
  import { useLoginStatus } from '@/utils/useStore'

  const { proxy } = getCurrentInstance()
  const _this = proxy
  const CP = store.getters['user/CP']
  const dialogVisible = ref(false)
  const logoUrl = computed(() => {
    return store.state.user.language == 'zh-cn' ? logoZh : logoEn
  })
  const isCn = computed(() => {
    return store.state.user.language == 'zh-cn'
  })
  const goCCB = () => {
    const CCB_URL = useLoginStatus()
      ? `${CONFIG.BASE_URL}${CP('redirect_accountinfo') ? '/admin/accountinfo' : '/card/view'}`
      : '/'
    _this.$router.push(CCB_URL)
    dialogVisible.value = false
  }
  const goCC = () => {
    console.log(`${CONFIG.CAMCARD_MAIN_URL}/card/personalcard`)
    location.href = `${CONFIG.CAMCARD_MAIN_URL}/card/personalcard`
    dialogVisible.value = false
  }
  const toSwitch = () => {
    dialogVisible.value = true
  }
</script>

<style lang="scss" scoped>
  %po {
    position: absolute;
    left: 0;
    top: 0;
    width: 150px;
    height: 100%;
    cursor: pointer;
    z-index: 1;
    background: transparent;
  }
  .logo-box {
    width: 250px;
    height: 56px;
    position: relative;
    img {
      position: relative;
      z-index: 0;
    }
    .to-link {
      @extend %po;
    }
    .to-switch {
      @extend %po;
      left: 150px;
      width: 100px;
      .select-menu-list {
        top: 50px;
        display: block;
        .flex {
          gap: 8px;
          height: auto;
          padding: 10px 12px;
        }
      }
      .name {
        font-size: 14px;
        color: var(--gray-21);
        line-height: 22px;
      }
      .desc {
        font-size: 12px;
        color: var(--gray-99);
        line-height: 18px;
      }
      .icomoon-check {
        margin-left: 8px;
        font-size: 20px;
        color: var(--blue);
      }
    }
  }
</style>
